<template>
  <div class="p-the-l04-pagination">
    <div class="p-the-l04-pagination__item">
      <template v-if="prevTitle">
        <a
          v-touch:tap
          :href="prevLink"
          class="p-the-l04-pagination__item__link"
        >
          <IconBase
            width="40"
            height="40"
            view-box="0 0 40 40"
            icon-color="#000000"
          >
            <IconArrowLeft40px />
          </IconBase>
          <p class="p-the-l04-pagination__item__text" data-translate-skip>
            {{ prevTitle }}
          </p>
        </a>
      </template>
    </div>
    <div class="p-the-l04-pagination__item">
      <template v-if="nextTitle">
        <a
          v-touch:tap
          :href="nextLink"
          class="p-the-l04-pagination__item__link p-the-l04-pagination__item__link--next"
        >
          <p class="p-the-l04-pagination__item__textright" data-translate-skip>
            {{ nextTitle }}
          </p>
          <IconBase
            width="40"
            height="40"
            view-box="0 0 40 40"
            icon-color="#000000"
          >
            <IconArrowRight40px />
          </IconBase>
        </a>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft40px from "@/common/components/icons/IconArrowLeft40px.vue";
import IconArrowRight40px from "@/common/components/icons/IconArrowRight40px.vue";
import TextSanitized from "@/common/components/atoms/TextSanitized.vue";
import store from "@/general/store";
import { Options, Vue } from "vue-class-component";
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    prevNews: { type: Object, required: false },
    nextNews: { type: Object, required: false }
  },
  components: {
    IconBase,
    IconArrowLeft40px,
    IconArrowRight40px,
    TextSanitized
  },
  store: store
})
export default class TheL04Pagination extends Vue {
  prevNews!: any;
  nextNews!: any;

  get prevLink() {
    return this.prevNews.link;
  }

  get nextLink() {
    return this.nextNews.link;
  }

  get prevTitle() {
    return this.prevNews.title;
  }
  get nextTitle() {
    return this.nextNews.title;
  }
}
</script>

<style lang="scss" scoped>
.p-the-l04-pagination {
  display: flex;
  padding: rem(20) 0;
  border-top: px(1) solid $common-gray-border;
  border-bottom: px(1) solid $common-gray-border;
  margin-top: rem(40);

  @include sp {
    padding: rem(8) 0;
  }

  &__item {
    width: 50%;

    &:first-of-type {
      padding: rem(24) rem(16) rem(24) 0;
      border-right: px(1) solid $common-gray-border;

      @include sp {
        padding: rem(12) rem(8) rem(12) 0;
      }

      p {
        margin-left: rem(16);

        @include sp {
          margin-left: rem(8);
        }
      }
    }

    &:last-of-type {
      padding: rem(24) 0 rem(24) rem(16);

      @include sp {
        padding: rem(12) 0 rem(12) rem(8);
      }

      p {
        margin-right: rem(16);

        @include sp {
          margin-right: rem(8);
        }
      }
    }

    &__link {
      display: flex;
      align-items: center;

      &--next {
        justify-content: right;
      }

      &.tap {
        opacity: 0.5;
      }
    }

    &__text {
      color: #4f4f4f;

      @include sp {
        flex: 1;
        text-align: center;
      }
    }

    &__textright {
      color: #4f4f4f;
      text-align: left;

      @include sp {
        flex: 1;
        text-align: center;
      }
    }
  }
}
</style>
